import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: readonly ClassValue[]): string {
  return twMerge(clsx(inputs));
}

/* `@planuze/ui` é a fonte canônica do tooling de variants (ADR-0118): além de
   `cn`, re-exporta `cva`/`VariantProps` para que features definam variantes sem
   depender direto de `class-variance-authority` (evita dep duplicada e mantém o
   design system como ponto único de entrada). */
export { cva, type VariantProps } from 'class-variance-authority';
